import { StyleSheet } from 'aphrodite';
import { charmGray } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	canvas: {
		overflow: 'hidden',
		pointerEvents: 'none',
	},
	caption: {
		color: charmGray,
		fontSize: 12,
		margin: 0,
	},
	previewWrapper: {
		minHeight: 0,
	},
});
